// Token validation utilities
export const getValidToken = () => {
  const token = localStorage.getItem('token');
  if (!token || token === 'null' || token === 'undefined') {
    // Clear invalid token
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    throw new Error('Oturum süresi dolmuş. Lütfen tekrar giriş yapın.');
  }
  return token;
};

export const isTokenValid = () => {
  try {
    getValidToken();
    return true;
  } catch {
    return false;
  }
};

export const handleTokenError = (error) => {
  // If token related error, clear storage and redirect to login
  if (error.response?.status === 401 || 
      error.message?.includes('token') || 
      error.message?.includes('oturum')) {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    window.location.href = '/login';
    return;
  }
  
  // Re-throw other errors
  throw error;
};